import { render, staticRenderFns } from "./Complimentaries.vue?vue&type=template&id=0d0d0ea8&scoped=true"
import script from "./Complimentaries.vue?vue&type=script&lang=js"
export * from "./Complimentaries.vue?vue&type=script&lang=js"
import style0 from "./Complimentaries.vue?vue&type=style&index=0&id=0d0d0ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0d0ea8",
  null
  
)

export default component.exports